//请自行添加语言资源
const confirm = {
  orderNo:'订单编号',
  planDeliveryDate:'预计到货日期',
  shiptoName:'送达方名称',
  soldName:'售达方名称',
  totalVolume:'总体积',
  shiptoTel:'送达方电话',
  totalNetWegit:'总净重',
  orderStatus:'订单状态',
  approveStatus:'审批状态',
  shiptoNo:'送达方编号',
  feedbackStatus:'SAP反馈状态',
  inputDate:'放入时间',
  orderRemark:'备注',
  customerNo:'客户编码',
  signRemark:'签收备注',
  totalPrice:'总价格（含税）',
  totalQty:'总数量',
  signDate:'签收时间',
  signUserNo:'签收用户',
  pickUpFlag:'是否自提',
  updateDate:'更新时间',
  orderDate:'订单日期',
  updateUserNo:'更新用户',
  shiptoAddr:'送达方地址',
  sapNo:'SAP编号',
  carrierName:'承运商',
  customerName:'客户名称',
  soldNo:'售达方编号',
  totalNoTaxPrice:'总价格（未税）',
  inputUserNo:'放入用户',
  totalGrossWegit:'总毛重',
  materielNo:'商品编号',
  materielName:'商品名称',
  orderQty:'订单数量',
  actShipQty:'发货数量',
  signQty:'签收数量',
  signAbnormalReason:'签收异常原因',
  endUserName:'终端客户',
  saleName:'销售',
  dangerousFlag:'危险品',
  netWeight:'单箱重量',
  volume:'单箱体积',
  taxPrice:'含税箱价',
  productNo:'产品编号',

  detail:'详情',
  currentApprover:'当前处理人',
  currentApproveLevel:'当前处理步骤',
  zsmpReqNo:'申请单号',
  reqEamilNo:'申请人邮箱',
  reqUserNo:'申请人',
  reqDate:'申请时间',
  reqType:'申请类型',
  regionName:'区域',
  channelName:'渠道',
  shipDcNo:'发货DC',
  shipNo:'ShipTo编号',
  shipName:'ShipTo',
  uploadCustomerName:'客户组',
  transOrderFlag:'转单次数',
  totalBoxQty:'内领单总箱数',
  totalPackageQty:'内领单总包数',
  actBoxQty:'抓单箱数',
  useBoxQty:'剩余可用箱数',
  ioNo:'IO号',
  ioStatus:'IO号状态',

  // productNo: 'SKU号码',
  // materielNo: '物料编号',
  zhName: '物料描述',
  typeName: '物料类型',
  categoryName: 'Category',
  tier: 'Tier',
  containerSize: '箱容',
  boxQty: '箱数',
  packageQty: '包数',
  shipAddressName: '送货方式',

  msg:{
  }
};
export default confirm



// WEBPACK FOOTER //
// ./src/page/order/soldBatchTest/lang/soldBatchTest.zh.js